import { atom } from 'recoil';

export const SelectedAudit = atom<{}>({
    key: 'selectedAudit',
    default: {},
});
